import React from "react";
import { Link } from "react-router-dom";

/**
 * Consistent layout for FAQ / Privacy / Terms pages.
 * Editorial forest hero band + cream body with generous whitespace.
 * Fully responsive on mobile + desktop.
 */
export default function LegalPage({ eyebrow, title, intro, updated, children }) {
  return (
    <div className="min-h-screen bg-mizizi-cream text-mizizi-charcoal">
      {/* Hero band */}
      <header className="bg-mizizi-forest text-mizizi-cream border-b border-mizizi-gold/30">
        <div className="max-w-4xl mx-auto px-5 sm:px-6 md:px-10 py-14 md:py-20">
          <div className="overline text-mizizi-gold mb-4 tracking-[0.3em]">{eyebrow}</div>
          <h1 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl leading-tight">
            {title}
          </h1>
          {intro && (
            <p className="mt-6 text-base md:text-lg text-mizizi-cream/85 max-w-2xl leading-relaxed">
              {intro}
            </p>
          )}
        </div>
      </header>

      {/* Body */}
      <main className="max-w-3xl mx-auto px-5 sm:px-6 md:px-10 py-14 md:py-20">
        <div className="prose-mizizi space-y-10 md:space-y-12">{children}</div>

        {updated && (
          <p className="mt-16 pt-8 border-t border-mizizi-charcoal/15 overline text-mizizi-charcoal/50">
            Last updated · {updated}
          </p>
        )}

        <div className="mt-12 flex flex-wrap gap-3">
          <Link to="/faq" className="pill pill-outline">FAQ & Refund</Link>
          <Link to="/privacy" className="pill pill-outline">Privacy</Link>
          <Link to="/terms" className="pill pill-outline">Terms of Use</Link>
        </div>
      </main>
    </div>
  );
}

// Small helper components for consistent section formatting inside legal pages.
export function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-serif font-light text-2xl md:text-3xl leading-tight text-mizizi-charcoal">{title}</h2>
      <div className="mt-4 space-y-3 text-base md:text-[17px] leading-[1.75] text-mizizi-charcoal/85 font-light">
        {children}
      </div>
    </section>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="mt-3 space-y-2 list-none">
      {items.map((it, i) => (
        <li key={i} className="pl-5 relative text-base md:text-[17px] leading-[1.75] text-mizizi-charcoal/85 font-light">
          <span className="absolute left-0 top-3 w-2 h-px bg-mizizi-gold" />
          {it}
        </li>
      ))}
    </ul>
  );
}
